import ChipMain from './Chip';
import type { IChipComponentType } from './Chip.types';

const Chip = ChipMain as IChipComponentType;

export { Chip };
export * from './Chip.types';
